import request from '@utils/request';
import {
  IPositionDeliveryStatus,
  IBindBoleInfo,
  IBoleInfo,
  IWorkCity,
  IVolunteerJobList,
  IDeliveryItem,
  IDeliveryInfo,
  IPage,
} from '@src/types';

// 投递相关

// 职位投递按钮状态
export async function getDeliveryStatus(params): Promise<IPositionDeliveryStatus> {
  const res = await request.post('/api/official/apply/job/deliveryStatus', params);
  return res;
}

/**
 * @description: 投递页历史投递信息
 * @param {*} params
 * @return {*}
 */
export async function getDeliveryInfo(params): Promise<IDeliveryInfo> {
  const res = await request.post('/api/official/volunteer/apply/job/get', params);
  return res;
}

// 校验内推码
export async function validRecommendNum(params): Promise<IBoleInfo> {
  const res = await request.post('/api/official/recommend/recommendationNum/check', params);
  return res;
}

// 简历二次投递确认页判断是否绑定伯乐
export async function getBoleInfo(params): Promise<IBindBoleInfo> {
  const res = await request.post('/api/official/recommend/getBoleInfo', params);
  return res;
}

// 根据BG获取期望工作城市
export async function getWorkCity(params): Promise<IWorkCity> {
  const res = await request.post('/api/official/job/getWorkCity', params);
  return res;
}

/**
 * @description: 获取志愿单职位列表
 * @return {*}
 */
export async function getVolunteerJobList(params): Promise<IVolunteerJobList> {
  const res = await request.post('/api/official/job/getVolunteerJobList', params);
  const list = (res?.list || []).map((item) => {
    item.jobId = item.jobUnionId;
    item.jobName = item.name;
    return item;
  });
  return { list };
}

// 投递页申请职位
export async function applyJob(params, config) {
  const res = await request.post('/api/official/apply/job', params, config);
  return res;
}

// 个人中心-投递进度查询
export async function getDeliveryList(params): Promise<{ applyRecords: IDeliveryItem[]; page: IPage }> {
  // const res = await request.get('/api/official/apply/operation/get');
  const res = await request.post('/api/official/apply/record/get', params);
  return res;
}

// 保存简历
export async function saveResume(params: {}) {
  const res = await request.post('/api/official/resume/save', params);
  return res;
}
